export default __webpack_public_path__ + "static/sherilyn-deen-908d763eaab08d48c0d6b45433d66f99.png";